const URL = 'https://api.spacexdata.com/v3/rockets';

export default URL;
